import { PropsWithChildren } from 'react';
import { cn } from '../../lib/utils';

interface DetailContainerProps extends PropsWithChildren {
  className?: string;
}

export function DetailContainer({ children, className }: DetailContainerProps) {
  return <div className={cn('flex flex-col gap-4 p-2 lg:p-4', className)}>{children}</div>;
}

interface DetailRowProps extends PropsWithChildren {
  className?: string;
}

export function DetailRow({ children, className }: DetailRowProps) {
  return <div className={cn('flex flex-row gap-4', className)}>{children}</div>;
}

interface DetailColumnProps extends PropsWithChildren {
  fullWidth?: boolean;
  third?: boolean;
  className?: string;
}

export function DetailColumn({ children, fullWidth, third, className }: DetailColumnProps) {
  return (
    <div
      className={cn(
        'flex flex-col gap-0.5',
        fullWidth && 'w-full',
        third && 'w-1/3',
        !fullWidth && !third && 'w-1/2',
        className
      )}
    >
      {children}
    </div>
  );
}
